import { TranslateModule } from '@ngx-translate/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { SessionsService } from './sessions/sessions.service';
import { HttpRequestInterceptorModule } from './framework/service/http-interceptor.service';
import { AuthenticationGuard } from './framework/guards/authentication.guard';
import { StepperNavigationModule } from './features/shared/components/stepper-navigation/stepper-navigation.module';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { OverlayContainer } from '@angular/cdk/overlay';
import { SharedModule } from './framework/shared/shared.module';
import { UserActivityModule } from './sessions/user-activity/user-activity.module';
import { AuthorizationGuard } from './framework/guards/authorization.guard';
import { InPageNavService } from './features/shared/components/in-page-nav/in-page-nav.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MyReportsComponent } from './features/my-reports/my-reports.component';
import { MyGenomeComponent } from './features/my-genome/my-genome.component';
import { MarketplaceComponent } from './features/marketplace/marketplace.component';
import { MyConsentComponent } from './features/my-consent/my-consent.component';
import { ConsentDialogComponent } from './consent-dialog/consent-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrivacyDialogComponent } from './privacy-dialog/privacy-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/framework/material/material.module';
import { DocViewerModule } from './features/shared/components/report-viewer/doc-viewer.module';


@NgModule({
  declarations: [
    AppComponent,
    MyReportsComponent,
    MyGenomeComponent,
    MarketplaceComponent,
    MyConsentComponent,
    PrivacyDialogComponent,
    ConsentDialogComponent,
    ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    HttpRequestInterceptorModule,
    StepperNavigationModule,
    UserActivityModule,
    TranslateModule.forRoot(),
    NgHttpLoaderModule.forRoot(),
    SharedModule,
    NgxChartsModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    HttpClientModule,
    MatDialogModule,
    MaterialModule,
    DocViewerModule
  ],
  providers: [SessionsService , AuthenticationGuard , AuthorizationGuard, InPageNavService],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(overlayContainer: OverlayContainer) {
    overlayContainer.getContainerElement().classList.add('seq-theme');
  }
}
